  import { Injectable } from "@angular/core";
  import { Observable, Subject } from "rxjs";

  @Injectable({
    providedIn: "root",
  })
  export class LoaderService {
    private loading = new Subject<boolean>();

    showLoader(): void {
      this.loading.next(true);
    }

    hideLoader(): void {
      this.loading.next(false);
    }

    isLoading(): Observable<boolean> {
      return this.loading.asObservable();
    }
  }
